/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SubletInputs */

const cs_enum_sublet = /** @type {(inputs: Enum_SubletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podnájem`)
};

const en_enum_sublet = /** @type {(inputs: Enum_SubletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublet`)
};

/**
* | output |
* | --- |
* | "Sublet" |
*
* @param {Enum_SubletInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sublet = /** @type {((inputs?: Enum_SubletInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SubletInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sublet(inputs)
	return cs_enum_sublet(inputs)
});